export enum VIDEO_MINIMIZED_MODES {
    CIRCLE = 'Circle',
    SQUARE = 'Square'
}
